<div class="flex h-[56px] items-center" [ngClass]="horizontalAlignCssClass">
  <div class="flex h-full w-[60px] items-center justify-center rounded border border-[lightgray]">
    <span>{{ val }}</span>
  </div>
</div>
